import React, { Component } from 'react';
import {Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FormData from 'form-data'

import classes from '../../../utils/cssClasses';
import Layout from '../Layout/Layout';
import { connect } from 'react-redux';
import * as actions from '../../../actions';

import FieldDropzone from '../FieldDropzone/FieldDropzone';
import BadgeClassList from '../BadgeClassList/BadgeClassList';


class Dashboard extends Component{
	constructor(props){
		super(props);

		this.state = {
			formLoading: false,
		}
	}

	componentDidMount() {
		this.props.fetchIssuer();
	}

	renderField(field) {
		// const { meta : {touched, error } } = field;
		const classGroup = `form-group  ${ field.meta.touched  && field.meta.error ? 'has-danger' : ''}`
		return (
			<div className={classes(classGroup)}>
				<label>{field.label} {field.meta.touched} { field.required ?  '*' : '' }</label>
				{ field.type === 'textarea' ? (
					<textarea
					className={classes('form-control')}
					type={field.type}
					{...field.input} />
				): ( 
					<input
						className={classes('form-control')}
						type={field.type}
						{...field.input} />
					)
			}
				{
					field.meta.touched ? (
					<div className={classes("invalid-feedback d-block")}>
						{ field.meta.error }
					</div>
					) : ''
				}
			</div>
			);
	}

	onSubmit(values) {
		// console.log(values);
		//  THAT Seems sooo wrong :/ 
		var body = new FormData();
	  Object.keys(values).forEach(( key ) => {
	  	if ((key === 'image'  || key === 'hero_image') && typeof values[key] === "object" ){
	    	body.append(key, values[ key ][0],values[ key ][0].fileName);
	  	}else{
		  	body.append(key, values[ key ]);
	  	}
	  });

		this.props.issuer.loading = true;
		this.props.updateIssuer(body);
		this.setState({
			...this.state,
			formLoading: true
		})
	}


	render() {

		if (this.props.issuer === null){
			return (
				<Layout />
				);
		}else{
			const { handleSubmit } = this.props;
			return ( 
				<Layout>
					<header>
						<div className={classes('row align-items-center')}>
							<div className={classes('col-auto')}>
								<FieldDropzone
									name="image" />
							</div>
							<div className={classes('col')}>
								<Field
									type="text"
									label="Nome Issuer"
									name="name"
									className={classes('form-control form-control-lg')}
									component={this.renderField}
									required
								/>
							</div>
						</div>
					</header>
					<hr/>
					<div className={classes('row')}>
						<div className={classes('col-12 col-md-6')}>
							<form
								onSubmit={handleSubmit(this.onSubmit.bind(this))}>
								<Field
									type="textarea"
									label="Descrizione"
									name="description"
									component={this.renderField}
								></Field>
								<Field
									type="text"
									label="Url"
									name="url"
									component={this.renderField}
								></Field>
								<Field
									type="email"
									label="Email"
									name="email"
									component={this.renderField}
								></Field>
								<Field
									type="text"
									label="Numero di telefono"
									name="telephone"
									component={this.renderField}
								></Field>
								<button type="submit" className={classes('btn btn-primary btn-lg')} >Salva</button>
								{ this.props.issuer.loading ? (
	    							<FontAwesomeIcon icon="spinner" spin  />
									) : ''}
							</form>
						</div>
						<div className={classes('col-12 col-md-6')}>
							<h3>Lista badges</h3>
							<BadgeClassList />
						</div>
					</div>
				</Layout>
			);
		}
	}
}

function mapStateToProps( {issuer} ){
	return {
		issuer,
		initialValues: issuer
	};
}

function validate(values){
	const errors = {};

	//validate inputs
	if (!values.name){
		errors.name = "Campo obbligatorio";
	}

	return errors;
}

export default connect(mapStateToProps,actions)(reduxForm({
	validate,
  enableReinitialize: true, 
	form: 'editIssuer'
})(Dashboard));


// WEBPACK FOOTER //
// ./src/components/Backend/Dashboard/Dashboard.js